// @flow

import { declareAction, declareAtom } from '@reatom/core'
import axios from 'axios'

import { GenerateKidPic } from '@bfg/atoms/Generator'
import * as common from '@bfg/common'
import { AppConfigAtom } from '@bfg/atoms/AppConfig'
import { UtmAnalytics } from '@bfg/atoms/UtmAnalytics'
import { PaymentType } from '@bfg/enums/PaymentTypesEnum'
import { NRError, NRSuccess, NRUnSubscribed } from '@bfg/atoms/NewRelic'
import { SkipStepExperimentEnum } from '@bfg/enums/SkipStepExperimentEnum'

export const SetExpirationDate = declareAction(
  'setExpirationDateAction'
  // (payload, store) => {
  //   localStorage.setItem('paymentState', JSON.stringify(store.getState(PaymentAtom)));
  // }
)

export const SetTrial = declareAction('setTrialAction')

export const SetTrialPayment = declareAction(
  'setTrialPaymentAction',
  (payload, store) => {
    const appState = store.getState(AppConfigAtom)
    axios.post(`${common.api}/subscriber/${appState.fingerprint}/subscribe/trial`).then(res => {
      // const expirationDate = moment(res.data.expire_date).valueOf();
      const expirationDate = (new Date(res.data.expire_date)).getTime()
      store.dispatch(SetTrial(true))
      store.dispatch(SetExpirationDate(expirationDate))
      store.dispatch(GenerateKidPic())
    })
  }
)

export const ShowSuccessfulPaymentPopup = declareAction('showSuccessfulPaymentPopupAction')
export const HideSuccessfulPaymentPopup = declareAction('hideSuccessfulPaymentPopupAction')

export const SuccessfulPayment = declareAction(
  'successfulPaymentAction',
  (payload, store) => {
    // localStorage.setItem('paymentState', JSON.stringify(store.getState(PaymentAtom)));
    const expirationDate = (new Date(payload.date)).getTime()
    // const expirationDate = moment(payload).valueOf();
    store.dispatch(ShowSuccessfulPaymentPopup())
    store.dispatch(SetPayed(true))
    store.dispatch(SetExpirationDate(expirationDate))
    store.dispatch(GenerateKidPic())
    // if (SkipStepExperimentEnum.dontSkip === payload.experiment) {
    //   store.dispatch(GenerateKidPic({ experiment: 0 }))
    // }
    // if (SkipStepExperimentEnum.skip === payload.experiment) {
    //   store.dispatch(GenerateKidPic({ experiment: 1 }))
    // }
  }
)

export const UnSuccessfulPayment = declareAction('unSuccessfulPaymentAction')

export const SetPayed = declareAction('setPayedAction')
export const SetExpired = declareAction('setExpiredAction')
export const SetCanceled = declareAction('setCanceledAction')
export const SetCancelAtPeriodEnd = declareAction('setCancelAtPeriodEndAction')

// ==============================================================
export const SetSetupState = declareAction('setSetupStateAction')

export const SetPaymentError = declareAction('setPaymentErrorAction')

export const Unsubscribe = declareAction(
  'unsubscribeAction',
  (payload, store) => {
    const appState = store.getState(AppConfigAtom)
    axios.post(
      `${common.api}/subscriber/${appState.fingerprint}/unsubscribe`
      // `${common.api}/subscriber/${appState.fingerprint}/unsubscribe/bluesnap`
    )
      .then(
        res => {
          // store.dispatch(SetCancelAtPeriodEnd(true));
          store.dispatch(SetCanceled(true))
          store.dispatch(SetPayed(false))
          store.dispatch(SetTrial(false))
          store.dispatch(SetExpirationDate(null))
          store.dispatch(NRUnSubscribed(NRSuccess))
        }
      )
      .catch(e => {
        console.error(e)
        store.dispatch(NRUnSubscribed(NRError))
      })
  }
)

export const SetPaymentProcessor = declareAction('setPaymentProcessorAction')

const findPaymentType = (types, type) => {
  const found = types.find(_type => _type.type === type)
  return found || null
}
export const GetPaymentType = declareAction(
  'getPaymentTypeAction',
  (payload, store) => {
    const utmState = store.getState(UtmAnalytics)
    const appConfig = store.getState(AppConfigAtom)
    // Спец-план 'rewardful' гейтим по ВАЛИДИРОВАННОМУ rwReferral (UUID от rw.js),
    // а НЕ по сырому ?via= — иначе любой ?via=blabla получил бы скидку.
    // rwReferral появляется асинхронно (после ready), поэтому при первой загрузке
    // обычно отдаётся default/utm_source, а на ready планы перезапрашиваются (см. index.js).
    // Если в БД нет PaymentType с name='rewardful', бэк отдаёт default.
    const type = utmState.rwReferral
      ? 'rewardful'
      : (utmState.utmSource === null ? 'default' : utmState.utmSource)

    const aPayRequest = axios.get(`${common.api}/payment-type/${appConfig.gateway.aPay}/${type}`)
    const gPayRequest = axios.get(`${common.api}/payment-type/${appConfig.gateway.gPay}/${type}`)

    // Promise.all сохраняет порядок: [aPayResponse, gPayResponse]
    Promise.all([aPayRequest, gPayRequest])
      .then(([aPayResponse, gPayResponse]) => {
        const aPay = {
          oneTimePay: findPaymentType(aPayResponse.data, PaymentType.OneTimePayment),
          weeklySub: findPaymentType(aPayResponse.data, PaymentType.WeeklySubscription),
          monthlySub: findPaymentType(aPayResponse.data, PaymentType.MonthlySubscription),
          annualSub: findPaymentType(aPayResponse.data, PaymentType.AnnualSubscription),
        }
        const gPay = {
          oneTimePay: findPaymentType(gPayResponse.data, PaymentType.OneTimePayment),
          weeklySub: findPaymentType(gPayResponse.data, PaymentType.WeeklySubscription),
          monthlySub: findPaymentType(gPayResponse.data, PaymentType.MonthlySubscription),
          annualSub: findPaymentType(gPayResponse.data, PaymentType.AnnualSubscription),
        }
        store.dispatch(SetPaymentTypes({ aPay, gPay }))
      })
      .catch(console.error)
  }
)

export const SetPaymentTypes = declareAction(
  'setPaymentsTypesAction',
  ((payload, store) => {
    store.dispatch(CheckIsPaymentInit())
  })
)
export const GetGateway = declareAction(
  'getGatewayAction',
  (payload, store) => {
    axios.get(`${common.api}/determine-gateway`)
      .then(resp => {
        store.dispatch(SetGateway(resp.data.gateway))
        store.dispatch(CheckIsPaymentInit())
      })
      .catch(console.error)
  }
)
export const SetGateway = declareAction('setGatewayAction')
const CheckIsPaymentInit = declareAction(
  'checkIsPaymentInitializedAction',
  ((payload, store) => {
    const paymentAtomState = store.getState(PaymentAtom)

    // Проверяем что хотя бы один тип платежа загружен для aPay
    const aPayLoaded = (
      paymentAtomState.aPay.oneTimePay !== null ||
      paymentAtomState.aPay.weeklySub !== null ||
      paymentAtomState.aPay.monthlySub !== null ||
      paymentAtomState.aPay.annualSub !== null
    )

    // Проверяем что хотя бы один тип платежа загружен для gPay
    const gPayLoaded = (
      paymentAtomState.gPay.oneTimePay !== null ||
      paymentAtomState.gPay.weeklySub !== null ||
      paymentAtomState.gPay.monthlySub !== null ||
      paymentAtomState.gPay.annualSub !== null
    )

    // Инициализировано когда оба загружены
    if (aPayLoaded && gPayLoaded) {
      store.dispatch(PaymentInitialized())
    }
  })
)
export const PaymentInitialized = declareAction('paymentInitializedAction')
export const PaymentReady = declareAction('paymentReadyAction')
export const SetPaymentType = declareAction('setPaymentTypeAction')
export const SetSubscriptionPaymentType = declareAction('setSubscriptionPaymentTypeAction')

/**
 * Цена, зафиксированная за подпиской: её валюта и сумма в этой валюте.
 * В membership показываем именно её, а не пересчитанную по текущему IP —
 * Stripe валюту подписки менять не даёт, и человек платит в той, в которой
 * оформлял.
 */
export const SetSubscriptionPrice = declareAction('setSubscriptionPriceAction')
export const SetCurrentSubscriptionId = declareAction(
  'setCurrentSubscriptionIdAction',
  ((payload, store) => {
    localStorage.setItem('currentSubStripeId', payload)
  }))

const loadInitState = () => {
  const currentSubStripeId = localStorage.getItem('currentSubStripeId')
  return {
    // null у долларовых подписок и у всех, оформленных до мультивалютности.
    subscriptionPrice: null,
    ready: false,
    initialized: false,
    payed: false,
    expired: false,
    canceled: false,
    cancelAtPeriodEnd: false,
    paymentError: null,
    expirationDate: null,
    trial: false,
    showSuccessPopup: false,
    processor: null,
    aPay: {
      oneTimePay: null,
      weeklySub: null,
      monthlySub: null,
      annualSub: null,
    },
    gPay: {
      oneTimePay: null,
      weeklySub: null,
      monthlySub: null,
      annualSub: null,
    },
    gateway: null,
    paymentType: null,
    setupDone: null,
    subscriptionPaymentType: null,
    currentSubscriptionId: currentSubStripeId,
  }
}

const initState = loadInitState()

export const PaymentAtom = declareAtom(
  'paymentAtom',
  initState,
  on => [
    on(SetPayed, (state, payload) => {
      return { ...state, payed: payload }
    }),
    on(SetExpired, (state, payload) => {
      return { ...state, expired: payload }
    }),
    on(SetSetupState, (state, payload) => {
      // console.log(payload, 'setSetupState')
      return { ...state, setupDone: payload }
    }),
    on(SetCanceled, (state, payload) => {
      return { ...state, canceled: payload }
    }),
    on(SetCancelAtPeriodEnd, (state, payload) => {
      return { ...state, cancelAtPeriodEnd: payload }
    }),
    on(SetExpirationDate, (state, payload) => {
      return { ...state, expirationDate: payload }
    }),
    on(SetTrial, (state, payload) => {
      return { ...state, trial: payload }
    }),
    on(SetPaymentError, (state, payload) => {
      return { ...state, paymentError: payload }
    }),
    on(ShowSuccessfulPaymentPopup, (state, payload) => {
      return { ...state, showSuccessPopup: true }
    }),
    on(HideSuccessfulPaymentPopup, (state, payload) => {
      return { ...state, showSuccessPopup: false }
    }),
    on(SetPaymentProcessor, (state, payload) => {
      return { ...state, processor: payload }
    }),
    on(SetPaymentTypes, (state, payload) => {
      return {
        ...state,
        aPay: payload.aPay,
        gPay: payload.gPay,
      }
    }),
    on(SetGateway, (state, payload) => {
      return {
        ...state,
        gateway: payload
      }
    }),
    on(PaymentInitialized, (state, payload) => {
      return {
        ...state,
        initialized: true,
      }
    }),
    on(PaymentReady, (state, payload) => {
      return {
        ...state,
        ready: true,
      }
    }),
    on(SetPaymentType, (state, payload) => {
      return {
        ...state,
        paymentType: payload,
      }
    }),
    on(SetSubscriptionPrice, (state, payload) => {
      return { ...state, subscriptionPrice: payload || null }
    }),
    on(SetSubscriptionPaymentType, (state, payload) => {
      return {
        ...state,
        subscriptionPaymentType: payload,
      }
    }),
    on(SetCurrentSubscriptionId, (state, payload) => {
      return {
        ...state,
        currentSubscriptionId: payload,
      }
    })
  ]
)
